import { render, staticRenderFns } from "./cooperate-partner.vue?vue&type=template&id=1077dc58&scoped=true&"
import script from "./cooperate-partner.vue?vue&type=script&lang=js&"
export * from "./cooperate-partner.vue?vue&type=script&lang=js&"
import style0 from "./cooperate-partner.vue?vue&type=style&index=0&id=1077dc58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1077dc58",
  null
  
)

export default component.exports